import React, { useState } from 'react'
import SEO from './templates/SEO'
import Header from './templates/Header'
import Footer from './templates/Footer'
import emailjs from 'emailjs-com';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

function Payment() {

    
const Result = () => {
    return <p className="success-message fw-bold text-success">Your Message has been successfully sent. We will contact you soon.</p>;
  };

    const [searchParams] = useSearchParams();

    const courseName = searchParams.get('course-name');
    const category = searchParams.get('category');
    const price = searchParams.get('price')* 1.18;;

    let nav = useNavigate();

    const RAZORPAY_KEY_ID = 'rzp_live_LsVHHXCHVCLcRc'

     const [result, showresult] = useState(false);
      const [formErrors, setFormErrors] = useState({});
      const [formData, setFormData] = useState({
        fullname: '',
        email: '',
        phone: '',
        age: '',
      });
    
      // const validate = (name, value) => {
      //   let errors = { ...formErrors };
    
      //   switch (name) {
      //     case 'fullname':
      //       errors.fullname = !/^[A-Za-z][A-Za-z\s\-]{3,}$/.test(value) ? 'Full Name must be alphabet and at least 3 characters' : '';
      //       break;
      //     case 'email':
      //       errors.email = !/^\S+@\S+\.\S+$/.test(value) ? 'Invalid email address' : '';
      //       break;
      //     case 'phone':
      //       errors.phone = !/^\d{10}$/.test(value) ? 'Phone number must be 10 digits' : '';
      //       break;
      //     default:
      //       break;
      //   }
    
      //   setFormErrors(errors);
      // };
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
      };
    
      const handleKeyUp = (e) => {
        const { name, value } = e.target;
        // validate(name, value);
      };
    
      const isValid = () => {
        return !Object.values(formErrors).some(error => error) &&
               formData.fullname && formData.email && formData.phone && formData.age;
      };
    
      const sendEmail = async (e) => {
        e.preventDefault();
        // if (!isValid()) {
        //   alert("Please fix the errors before submitting.");
        //   return;
        // }

        console.log(formData);
    
        try {
          const data = {
            user_id : '100',
            name : formData.fullname,
            email: formData.email, 
            age : formData.age,
            phone: formData.phone,
            amount : price,
            currency: 'INR'
          }
          // Make the API call to backend
          const response = await fetch("https://tradingwhales.in:5000/api/createOrder", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          const order = await response.json();
          console.log("Order response>>",order)
        // add option for the payment gateway it can be dynamic if you want 
        // we can use prop drilling to make it dynamic
          const options = {
            key: 'rzp_live_LsVHHXCHVCLcRc',
            amount: order.amount,
            currency: order.currency,
            name: courseName, // Add company details
            description: "Payment for Course", // Add order details
            order_id: order.order_id,
            // this is make function which will verify the payment
            // after making the payment 
            handler: async (response) => {
              console.log("Handler Response", response);
              try {

                const verifyResponse = await fetch("https://tradingwhales.in:5000/api/verifyPayment", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                
                  body: JSON.stringify({
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                    order_id:order.order_id
                  }),
                });
                // Add onPaymentSuccessfull function here
                console.log("Response Callback", verifyResponse)
                // alert("Payment successful!");
                nav("/payment-success");
              } catch (err) {
                // Add onPaymentUnSuccessfull function here
                alert("Payment failed: " + err.message);
              }
            },
            prefill: {
              name: "demouser", // add customer details
              email: "demouser@example.com", // add customer details
              contact: "1111111111", // add customer details
            },
            notes: {
              address: "Razorpay",
            },
            theme: {
        // you can change the gateway color from here according to your
        // application theme
              color: "#479536",
            },
          };
          const rzp = new window.Razorpay(options);
          rzp.open();
        //   // this will open razorpay window for take the payment in the frontend
        //   // under the hood it use inbuild javascript windows api 
          
        } catch (err) {
          alert("Error creating order: " + err.message);
        }
        
        // console.log('Form Submitted:', formData);
        // alert('Payment submitted successfully!');

        
        // e.target.reset();
        // showresult(true);
        // setTimeout(() => showresult(false), 5000);
        // setFormData({ fullname: '', email: '', phone: '', subject: '', message: '' });
        // setFormErrors({});

      };
      
    

      
  return (
    <div>

<SEO title="Payment Page"/>
            
            <Header/>

            <div className="loginarea sp_bottom_100">
        <div className="container">
          <div className="row align-items-center w-100 mx-auto">
          <div className="col-xl-6 col-lg-6 col-md-6">
                <h1>Course Name: {courseName}</h1>
                <h2>Category: {category}</h2>
                <h2>Total Payable Amount: {price}</h2>
                <small>By Clicking on Buy Now, you agree to our terms & conditions</small>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="loginarea__wraper">
                <div className="login__heading">
                  <h5 className="login__title">Please Fill Your Details</h5>
                </div>

                <form onSubmit={sendEmail}>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your Full Name"
                      name="fullname"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      required
                    />
                    {/* {formErrors.fullname && <small style={{ color: 'red' }}>{formErrors.fullname}</small>} */}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your email address"
                      name="email"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      
                    />
                    {/* {formErrors.email && <small style={{ color: 'red' }}>{formErrors.email}</small>} */}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your phone number"
                      name="phone"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      required
                      maxLength={10}
                    />
                    {/* {formErrors.phone && <small style={{ color: 'red' }}>{formErrors.phone}</small>} */}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your Age"
                      name="age"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      maxLength={2}
                    />
                    {/* {formErrors.phone && <small style={{ color: 'red' }}>{formErrors.phone}</small>} */}
                  </div>
                  <div className="login__button">
                    <input type="submit" className="default__button" value="Buy Now" />
                  </div>
                </form>

                <div className="form-group">
                  {result ? <Result /> : null}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
            
            <Footer/>
      
    </div>
  )
}



export default Payment
